<div class="background-cover"></div>
<div class="ops-recurring-modal">
  <div class="cssload-container" *ngIf="isLoading">
    <div class="cssload-speeding-wheel"></div>
  </div>
  <label class="section-label"
    >{{ isCreate ? ('labels.make' | translate) : ('labels.edit' | translate) }}
    {{ 'labels.recurringCost' | translate }}</label
  >

  <div class="body-form">
    <ops-select
      [options]="frequencyOptions"
      [defaultSelected]="frequency"
      [formName]="frequency"
      [label]="'labels.recurring' | translate"
      (changed)="onFrequencySelected($event)"
    ></ops-select>
    <ops-calendar
      [label]="'labels.endDate' | translate"
      (dateChanged)="onEndDateChange($event)"
      formName="endDate"
      [date]="endDate"
    ></ops-calendar>
  </div>

  <div class="create-actions">
    <button class="delete-button" (click)="onDelete()" *ngIf="!isCreate">
      {{ 'labels.delete' | translate }}
    </button>
    <button class="cancel-button" (click)="closeModalHandle()">
      {{ 'labels.cancel' | translate }}
    </button>
    <button
      class="save-button"
      [class.disabled]="!isValid"
      [disabled]="!isValid"
      (click)="saveChanges()"
    >
      {{ 'labels.save' | translate }}
    </button>
  </div>
</div>
